export default function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative bg-[#140a0c] text-white overflow-hidden">
      {image && (
        <>
          <div className="absolute inset-0 stage-scrim" aria-hidden="true" />
          <img src={image} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        {eyebrow && <span className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#bf6163]">{eyebrow}</span>}
        <h1 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-base sm:text-lg text-[#dfd8da] max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}
